import { Button, Checkbox, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useDisclosure, useToast, Grid, GridItem, Spinner, Center } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { fetchExportVacancy, fetchExportVacancyFields } from "../../store/slices/vacancy";

interface IExportVacancyModal {
    vacancyId: number;
}

export const ExportVacancyModal = ({ vacancyId }: IExportVacancyModal) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const dispatch = useAppDispatch();
    const toast = useToast();
    const { exportVacancyFields, isLoading } = useAppSelector(state => state.vacancy);
    const [selectedFields, setSelectedFields] = useState<string[]>([]);

    useEffect(() => {
        if (isOpen) {
            dispatch(fetchExportVacancyFields(vacancyId));
        }
    }, [isOpen, dispatch, vacancyId]);

    const handleCheckboxChange = (fieldKey: string) => {
        setSelectedFields(prev => 
            prev.includes(fieldKey) 
                ? prev.filter(key => key !== fieldKey)
                : [...prev, fieldKey]
        );
    };

    const handleExport = async () => {
        try {
            const result = await dispatch(fetchExportVacancy({
                id: vacancyId,
                params: {
                    fields: selectedFields
                }
            })).unwrap();

            // Создаем ссылку для скачивания
            const url = window.URL.createObjectURL(result);
            const a = document.createElement('a');
            a.href = url;
            a.download = `vacancy_${vacancyId}.docx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            toast({
                title: "Успешно",
                description: "Вакансия успешно выгружена",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: "Ошибка",
                description: "Произошла ошибка при выгрузке вакансии",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
        onClose();
    };

    return (
        <>
            <Button 
                onClick={onOpen}
                colorScheme="blue"
                variant="outline"
                disabled={true}
            >
                Экспорт
            </Button>

            <Modal isOpen={isOpen} onClose={onClose} size="xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Выбор полей для выгрузки</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {isLoading ? (
                            <Center h="200px">
                                <Spinner size="xl" color="blue.500" />
                            </Center>
                        ) : (
                            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                                {exportVacancyFields && Object.entries(exportVacancyFields).map(([key, value]) => (
                                    <GridItem key={key}>
                                        <Checkbox
                                            isChecked={selectedFields.includes(key)}
                                            onChange={() => handleCheckboxChange(key)}
                                        >
                                            <Text>{value}</Text>
                                        </Checkbox>
                                    </GridItem>
                                ))}
                            </Grid>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={onClose}>
                            Отмена
                        </Button>
                        <Button 
                            colorScheme="blue" 
                            onClick={handleExport}
                            isDisabled={selectedFields.length === 0 || isLoading}
                            isLoading={isLoading}
                        >
                            Выгрузить
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}; 